export const determineFileType = (field: string): string => {
  if (field === 'statute_document') return 'DOCUMENTO DE PARCEIRIA';
  if (field === 'election_act_document') return 'ATA-CMDRS';
  return '';
};

export const isInvalidEmail = (email?: string): boolean => {
  const trimmed = (email ?? '').trim();
  if (trimmed === '') return false;
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return !emailRegex.test(trimmed);
};

export const validateForm = (formData: any): boolean => {
  if (!formData) return false;

  const obrigatorios = [
    formData.entity_name,
    formData.entity_type,
    formData.cnpj_status,
    formData.latitude,
    formData.longitude,
    formData.informant_name,
    formData.informant_document,
    formData.informant_phone,
  ];

  const todosPreenchidos = obrigatorios.every(
    (campo) => campo !== null && campo !== undefined && campo !== ''
  );

  const produtosValidos =
    formData.collectionProducts?.length === 0 ||
    (Array.isArray(formData.collectionProducts) &&
      formData.collectionProducts.every((p: any) => {
        const valor =
          typeof p.commercialized_volume === 'string'
            ? parseFloat((p.commercialized_volume as string).replace(',', '.'))
            : p.commercialized_volume;

        return (
          p.product?.name &&
          p.product?.type &&
          Number.isFinite(valor) &&
          valor > 0
        );
      }));

  const CicaafCnpjStatusEnum = [
    'ATIVA',
    'SUSPENSA',
    'INAPTA',
    'ATIVA NÃO REGULAR',
    'BAIXADA',
    'NULA',
  ];

  const cnpjStatusValido = CicaafCnpjStatusEnum.includes(formData.cnpj_status);

  return todosPreenchidos && produtosValidos && cnpjStatusValido;
};

export const buildPayload = (formData: any): any => {
  if (!formData) return null;

  return {
    uuid: formData.uuid,
    reference_year: formData.reference_year,
    entity_name: formData.entity_name,
    entity_address: formData.entity_address,
    entity_email: formData.institution?.email,
    president_responsible_name: formData.president_responsible_name,
    entity_type: formData.entity_type,
    location_type: formData.location_type,
    cnpj_status: formData.cnpj_status,
    belongs_to_association_cooperative: formData.belongs_to_association_cooperative,
    parent_association_cooperative_uuid: formData.parent_association_cooperative_uuid,
    latitude: Number(formData.latitude),
    longitude: Number(formData.longitude),
    informant_name: formData.informant_name,
    informant_document: formData.informant_document,
    informant_phone: formData.informant_phone,
    informant_email: formData.informant_email,
    president_name: formData.president_name,
    total_members: formData.total_members,
    female_members: formData.female_members,
    indigenous_members: formData.indigenous_members,
    young_members: formData.young_members,
    observations: formData.observations,
    collectionProducts: formData.collectionProducts?.map((item: any) => ({
      uuid: item.uuid,
      commercialized_value: item.commercialized_value,
      commercialized_volume: item.commercialized_volume,
      measurement_unit: item.measurement_unit,
      product: {
        uuid: item.product?.uuid,
        name: item.product?.name,
        type: item.product?.type,
      },
    })),
    statute_document: formData.statute_document?.uuid,
    election_act_document: formData.election_act_document?.uuid,
  };
};
